import { render } from "./PanelAvisos.vue?vue&type=template&id=1487357b"
import script from "./PanelAvisos.vue?vue&type=script&lang=ts"
export * from "./PanelAvisos.vue?vue&type=script&lang=ts"
script.render = render

export default script